import { render, staticRenderFns } from "./CollectionCard.vue?vue&type=template&id=e4ea4608&"
import script from "./CollectionCard.vue?vue&type=script&lang=js&"
export * from "./CollectionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports